/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper';
import { v4 as uuidv4 } from 'uuid';



export default declareEntity({
    entity: "organisationNotifications",
    graphQL: "OrganisationNotification",
    name: "Organisation's Notifications",
    dynamoPrefix: 'org',
    storageType: 'central',
    userEditable: false, // all modyfying operation
    userUpdatable: false, // allow editing
    userDeletable: false, // allow remove
    defaultOrder: [['createdAt', 'desc']],
    fields: (types) => { return {
        id: {
            name: "Organisation Notification ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
            userEditable: false,
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
            userEditable: false,
        },
        organisation: {
            name: "Organisation ID",
            type: "relation",
            to: () => types['organisations'],
            defaultValue: (organisation) => {
                return organisation['id'];
            },
            required: true,
            parent: true,
            hiddenCreate: true,
        },
        recipients: {
            name: "Recipients",
            type: "object",
            defaultValue: "",
        },
        template: {
            name: "Template",
            type: "string",
            defaultValue: "",
        },
        subject: {
            name: "Subject",
            type: "string",
            defaultValue: "",
        },
        body: {
            name: "Message body",
            type: "html",
            defaultValue: "",
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            defaultValue: (job) => {
                return job['channel_id'];
            },
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
            defaultValue: (job) => {
                return job['flow_id'];
            },
        },
        channelDef: {
            name: "Application Type",
            to: () => types['channelDefs'],
            type: "relation",
            defaultValue: (job) => {
                return job['channelDef_id'];
            },
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
            defaultValue: (job) => {
                return job['flowDef_id'];
            },
        },
        updatedAt: {
            name: "Updated At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        },
        author: {
            name: "Created By",
            type: "relation",
            to: () => types['users'],
            userEditable: false,
        },

    }; },
    relations: (types) => { return {
    }; }
});
